import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Dirfs = () => import('./Dirfs.vue')

export default {
    path: 'dirfs',
    name: 'FornecedorDirfs',
    component: Dirfs,
    beforeEnter: (to, from, next) => {
        if (temAcesso('FORN-DIRF-00')) {
            next()
        }
    },
    children: [
        // {
        // path: 'atualizar',
        // name: 'FornecedorDadosCadastrais_Atualizar',
        // component: DadosCadastraisForm,
        // beforeEnter: (to, from, next) => {
        //     if (temAcesso('FORN-DADOS-01')) {
        //         next()
        //     }
        // }
        // }
    ]
}
